// Opening a share's link (issue 1171): `/library/shared/<token>`. A person the owner named, signed in here, is granted
// the share — it is in their Library under "Shared with you" from now on. Anyone else is told exactly what a link
// that does not exist tells them: not found. The page never shows a picture; the files are fetched only in the
// Library, with the bearer, as the person's own are.
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { hasSession, siteUrl } from '../session';
import { claimShare, type ClaimResult } from '../shares';

export function SharedLink() {
  const { token = '' } = useParams();
  const signedIn = hasSession();
  const [result, setResult] = useState<ClaimResult | null>(null);
  useEffect(() => {
    if (signedIn) void claimShare(token).then(setResult);
  }, [token, signedIn]);
  return (
    <main className="flex min-h-screen items-center justify-center bg-stone-950 p-6 text-stone-100">
      <section className="w-full max-w-lg space-y-3 rounded-lg border border-stone-800 bg-stone-900 p-6" data-testid="shared-link">
        <h1 className="text-xl font-semibold">A shared library</h1>
        {!signedIn && (
          <p data-testid="shared-link-signin">Open one of your tables from <a className="underline" href={siteUrl() || '/'}>the site</a> first, so the tabletop knows who you are, then open this link again.</p>
        )}
        {signedIn && result === null && <p className="text-stone-400">Opening…</p>}
        {result?.kind === 'ok' && (
          <div className="space-y-2" data-testid="shared-link-ok">
            <p>"{result.share.name}" from {result.share.owner.handle ? `@${result.share.owner.handle}` : result.share.owner.displayName ?? 'someone'} is in your library.</p>
            <p className="text-sm text-stone-400">At any table you run, open the Library: it is under "Shared with you" — {result.share.pictures.length} {result.share.pictures.length === 1 ? 'picture' : 'pictures'} and {result.share.tracks.length} {result.share.tracks.length === 1 ? 'sound' : 'sounds'}.</p>
          </div>
        )}
        {result?.kind === 'not_found' && <p role="alert" data-testid="shared-link-not-found">This link was not found.</p>}
        {result?.kind === 'error' && <p role="alert">The link could not be opened right now. Try again.</p>}
      </section>
    </main>
  );
}
